
<template>
    <el-row>
    <el-form :model="IntranetClueItemForm"

                             ref="IntranetClueItemRef"
                             :rules="rules"
                             @onSelectInfo="onSelectInfo"
                             addAction="/clueCar/saveClueCar.action"
                             editAction="/clueCar/editClueCar.action"
                             selectAction="/clueCar/selectClueCar.action"
                             label-width="150px"
                             style="width:80%"
                             v-form>
      <el-row>
        <el-form-item label="品牌车型:" prop="category">
          <p>{{IntranetClueItemForm.brand}} {{IntranetClueItemForm.series}} {{IntranetClueItemForm.category}} {{IntranetClueItemForm.officePrice/(10000*100)}}万</p>
          <brand-and-series-categories-select @onChanged="carCategoryChange"
                                              brandPlaceholder="品牌（单选）" categoriesPlaceholder="车型(单选)"
                                              ref="brand-and-series-select"
                                              seriesPlaceholder="车系（单选）" :categoriesMultiple="false"></brand-and-series-categories-select>

        </el-form-item>
      </el-row>

      <el-row>
        <el-col :span="12">

          <el-form-item label="表显里程:" prop="mileage">
            <el-input v-model="IntranetClueItemForm.mileage"  type="number" placeholder="请输入（单位：万公里）"></el-input>
          </el-form-item>
          <el-form-item label="上牌日期:" prop="licenseTime">
            <el-date-picker
                v-model="IntranetClueItemForm.licenseTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上牌地址:" prop="licenseAddress">
            <search-city-input ref="licenseAddress" v-model="IntranetClueItemForm.licenseAddress" placeholder="请选择（支持搜索联想输入）" :defaultValue="IntranetClueItemForm.licenseAddress" @onChenged="onChangeLicenseAddress"></search-city-input>
          </el-form-item>
          <el-form-item label="车辆所属地:" prop="locationCity">
            <search-area-input ref="locationCity" v-model="IntranetClueItemForm.locationCity" placeholder="请选择（支持搜索联想输入）" :defaultValue="IntranetClueItemForm.locationCity" @onChenged="onChangeLocationCity"></search-area-input>
          </el-form-item>
          <el-form-item label="期望价格:" prop="expectedPrice">
            <el-input v-model="IntranetClueItemForm.expectedPrice" type="text" placeholder="比如 2.3万或者价格面议"></el-input>
          </el-form-item>

        </el-col>
        <el-col :span="12">

          <el-form-item label="使用性质:" prop="useNature">
            <el-select v-model="IntranetClueItemForm.useNature">
              <el-option label="非营运" value="非营运" ></el-option>
              <el-option label="营运" value="营运"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险到期:" prop="insuranceExpirationDate">
            <el-date-picker
                v-model="IntranetClueItemForm.insuranceExpirationDate"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
<!--          <el-form-item label="年检到期:" prop="inspectionExpirationDate">
            <el-date-picker
                v-model="IntranetClueItemForm.inspectionExpirationDate"
                type="date"
                value-format="timestamp"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>-->
          <el-form-item label="车辆描述:" prop="remark">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" v-model="IntranetClueItemForm.remark" placeholder="请输入（限制200字）"></el-input>
          </el-form-item>

        </el-col>

      </el-row>
      <el-row>
        <el-form-item label="车辆图片：" prop="descImgs">
          <draggable v-model="IntranetClueItemForm.descImgs" tag="ul" class="img-temp-list" draggable=".img-temp-item">
            <li class="img-temp-item" v-for="(item, i) in IntranetClueItemForm.descImgs" :key="i">
              <img :src="item.url" />
              <div class="img-action">
                <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                <i class="el-icon-delete" @click="removeFile(IntranetClueItemForm.descImgs,i)"></i>
              </div>
            </li>
            <el-upload
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :data="{floder:'clueCar'}"
                :file-list="IntranetClueItemForm.descImgs"
                :http-request="onHttpRequest"
                :limit="9"
                accept="image/*"
                action="upload/uploadPic"
                list-type="picture-card"
                multiple
                ref="descImgs"
                v-model="IntranetClueItemForm.descImgs">

              <i class="el-icon-plus"></i>
            </el-upload>
          </draggable>

        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="清洗截图：" prop="clearImgs">
          <draggable v-model="IntranetClueItemForm.clearImgs" tag="ul" class="img-temp-list" draggable=".img-temp-item">
            <li class="img-temp-item" v-for="(item, i) in IntranetClueItemForm.clearImgs" :key="i">
              <img :src="item.url" />
              <div class="img-action">
                <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
                <i class="el-icon-delete" @click="removeFile1(IntranetClueItemForm.clearImgs,i)"></i>
              </div>
            </li>
            <el-upload
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload1"
                    :data="{floder:'clueCar'}"
                    :file-list="IntranetClueItemForm.clearImgs"
                    :http-request="onHttpRequest"
                    :limit="9"
                    accept="image/*"
                    action="upload/uploadPic"
                    list-type="picture-card"
                    multiple
                    ref="clearImgs"
                    v-model="IntranetClueItemForm.clearImgs">

              <i class="el-icon-plus"></i>
            </el-upload>
          </draggable>

        </el-form-item>
      </el-row>
      <el-divider content-position="right"></el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="车主电话:" prop="phone">
            <el-input v-model="IntranetClueItemForm.phone" maxlength="11" type="text"></el-input>
          </el-form-item>

            <el-form-item label="是否接受拨号:" prop="dialPhoneCount">
                <el-select v-model="IntranetClueItemForm.dialPhoneCount" filterable allow-create>
                    <el-option label="接受" :value="-1"></el-option>
                    <el-option label="不接受" :value="0"></el-option>
                </el-select>
            </el-form-item>

          <el-form-item label="维护人:" prop="maintenanceEmployeeSnapid">
            <el-select v-model="IntranetClueItemForm.maintenanceEmployeeSnapid" @change="switchMainName">
              <el-option
                  v-for="item in maintenanceEmployees"
                  :key="item.maintenanceEmployeeSnapid"
                  :label="item.maintenanceName"
                  :value="item.maintenanceEmployeeSnapid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">

            <el-form-item label="车主姓名:" prop="name">
                <el-input v-model="IntranetClueItemForm.name" maxlength="10" type="text"></el-input>
            </el-form-item>

            <el-form-item label="线索来源:" prop="sourceType">
                <el-input v-model="IntranetClueItemForm.sourceType">
                </el-input>
            </el-form-item>

          <el-form-item label="线索备注:" prop="officeRemark">
            <el-input type="textarea" :autosize="{ minRows: 1, maxRows:1}" v-model="IntranetClueItemForm.officeRemark" placeholder="请输入（限制200字）"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="12">
          <el-form-item label="线索渠道类型:" prop="clueChannelType">
            <el-select v-model="IntranetClueItemForm.clueChannelType" filterable allow-create>
              <el-option label="普通线索" :value="1"></el-option>
              <el-option label="上汽专区线索" :value="2"></el-option>
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :span="12">
          <el-form-item label="线索等级:" prop="clueLevel">
            <el-select v-model="IntranetClueItemForm.clueLevel" filterable allow-create>
              <el-option label="普通线索(无图无描述)" :value="1"></el-option>
              <el-option label="优质线索(有图有描述)" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <el-button type="primary">保存为有效线索</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>

import SearchAreaInput from '@/components/SearchAreaInput'
import SearchCityInput from '@/components/SearchCityInput'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import draggable from 'vuedraggable'
export default {
  name: 'IntranetClueItem',
  extends: BasicPager,
  components: { BrandAndSeriesCategoriesSelect, SearchAreaInput, SearchCityInput, draggable },
  data: function () {
    let checkInt = (rule, value, callback) => {
      let match = (value + '').match(/^\d+(\.\d{0})?$/)
      if (!match) {
        return callback(new Error('只能为整数！'))
      }

      callback()
    }
    return {
      baseImageUrl: Config.imageUrl,
      baseSmalIcon: 'ClueDistribution/fdjxtb.png',

      maintenanceEmployees: [],
      rules: {
        category: [
          { required: true, message: '车型名称不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系手机号', trigger: 'blur' }, { min: 11, max: 11, message: '手机号位数错误，请修正！' }, { validator: checkInt, trigger: 'blur' }
        ],
        mileage: [
          { required: true, message: '请输入万公里', trigger: 'blur' }
        ],
        licenseTime: [
          { required: true, message: '请输入上牌时间', trigger: 'blur' }
        ],
        licenseAddress: [
          { required: true, message: '请输入车牌所在地', trigger: 'blur' }, { max: 40, message: '车牌所在地不能大于40位！' }
        ],
        locationCity: [
          { required: true, message: '请输入车辆所在地', trigger: 'blur' }, { max: 40, message: '车辆所在地不能大于40位！' }
        ],
        expectedPrice: [
          { required: true, message: '请输入期望价', trigger: 'blur' }, { max: 15, message: '期望价不能大于15位！' }
        ],
        maintenanceEmployeeSnapid: [
          { required: true, message: '请选择维护人', trigger: 'blur' }
        ],
        dialPhoneCount: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        useNature: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        clueLevel: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        clueChannelType: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      },
      IntranetClueItemForm: {
        id: null,
        brandId: null,
        seriesId: null,
        categoryId: null,
        brand: null,
        series: null,
        category: null,
        officePrice: null,
        descImgs: [],
        clearImgs: [],
        officeRemark: null,
        sourceType: null,
        maintenanceName: null,
        maintenanceEmployeeSnapid: null,
        useNature: '非营运',
        dialPhoneCount: -1,
        clueLevel: null,
        clueChannelType: null
      }
    }
  },
  created () {
    let userInfo = JSON.parse(localStorage.userInfo)

    this.findMaintenceUsersList()
    if (this.$route.params.id) {
      this.IntranetClueItemForm.id = this.$route.params.id
    } else {
      this.IntranetClueItemForm.maintenanceName = userInfo.realName
      this.IntranetClueItemForm.maintenanceEmployeeSnapid = userInfo.employeeSnapId
    }
  },
  methods: {
    switchMainName (data) {
      let maintenanceObject = this.maintenanceEmployees.find(function (item) {
        return item.maintenanceEmployeeSnapid === data
      })

      this.IntranetClueItemForm.maintenanceName = maintenanceObject.maintenanceName
    },
    findMaintenceUsersList () {
      let _this = this
      let params = { }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.maintenanceEmployees = dataInfo.datas
          }
        }

      }
      // 维护人列表
      BasicModel.post(_this, '/clueCar/findMaintenceUsersList.action', params, listener)
    },
    beforeAvatarUpload (file) {
      let _this = this
      let promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 15MB!')
          reject(new Error('上传头像图片大小不能超过 15MB!'))
          return
        }

        if (_this.IntranetClueItemForm.descImgs.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张'))
          return
        }
        resolve()
      })
      return promise
    },
    removeFile (list, index) {
      list.splice(index, 1)
    },
    beforeAvatarUpload1 (file) {
      let _this = this
      let promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 15MB!')
          reject(new Error('上传头像图片大小不能超过 15MB!'))
          return
        }

        if (_this.IntranetClueItemForm.clearImgs.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张'))
          return
        }
        resolve()
      })
      return promise
    },
    removeFile1 (list, index) {
      list.splice(index, 1)
    },
    onChangeLicenseAddress: function (addressInfo) {
      // 查询省市区areaCode

      let city = addressInfo.province + ' ' + addressInfo.city
      this.IntranetClueItemForm.licenseAddress = city
    },
    onChangeLocationCity: function (addressInfo) {
      // 查询省市区areaCode
      let city = addressInfo.province + ' ' + addressInfo.city + ' ' + addressInfo.county
      this.IntranetClueItemForm.locationCity = city
    },
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
        this.IntranetClueItemForm.categoryId = dataInfo.datas.categoryId
      }
      let status = dataInfo.datas.status

      if (status === 4 || status === 5) {
        this.IntranetClueItemForm.licenseAddress = null
        this.IntranetClueItemForm.locationCity = null
      }
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      // 品牌车系车型
      if (brandInfo) {
        this.IntranetClueItemForm.brandId = brandInfo.id
        this.IntranetClueItemForm.brand = brandInfo.name
      } else {
        this.IntranetClueItemForm.brandId = null
        this.IntranetClueItemForm.brand = null
      }

      if (seriesInfo) {
        this.IntranetClueItemForm.seriesId = seriesInfo.id
        this.IntranetClueItemForm.series = seriesInfo.name
      } else {
        this.IntranetClueItemForm.seriesId = null
        this.IntranetClueItemForm.series = null
      }

      if (categoriesInfo) {
        this.IntranetClueItemForm.categoryId = categoriesInfo.id
        this.IntranetClueItemForm.category = categoriesInfo.name
        this.IntranetClueItemForm.officePrice = categoriesInfo.price * 100
      } else {
        this.IntranetClueItemForm.categoryId = null
        this.IntranetClueItemForm.category = null
      }
    }
  },
  filters: {}

}
</script>

<style scoped>

  .img-temp-list {
    padding-left: 0;
    display: flex;
    align-items: center;
    flex-warp: warp;
  }

  .img-temp-item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
    position: relative;
  }

  .img-temp-item img {
    width: 100%;
    height: 100%;
  }
  .img-temp-item:hover .img-action {
    opacity: 1;
  }

  .img-temp-item .img-action {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    opacity: 0;
  }
  .img-action i {
    font-size: 20px;
    color: #fff;
    margin-left: 15px;
    cursor: pointer;
  }
  .img-action i:first-child {
    margin-left: 0;
  }
</style>
